<template>
  <layout :drawerShow="true">
    <template slot="drawer">
      <v-form ref="searchform" v-if="searchform" @submit.prevent="loadData">
        <v-row no-gutters class="pt-2 pr-1">
          <v-col cols="12" class="pr-1">
            <smart-multi-select
                v-model="searchform.selectedVirtualSites"
                label="Sites"
                :items="virtualSites"
                :all-is-same-as-empty="true"
                :default-select-all="true"
            ></smart-multi-select>
          </v-col>

          <v-col cols="12" class="mt-4">
            <v-subheader light class="pa-0 mb-0 mx-0 form-subheader"
            >Compagnies aériennes
            </v-subheader
            >
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12 mb-2">
            <v-text-field
                clearable
                v-model="searchform.airlines"
                label="Compagnies aériennes (séparées par une virgule)"
                placeholder=" "
                hide-details
            >
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-subheader light class="pa-0 mt-5 mb-0 mx-0 form-subheader"
            >Dates d'émission
            </v-subheader
            >
            <v-divider></v-divider>
          </v-col>
          <v-col class="pr-1" cols="6">
            <smart-picker
                v-model="searchform.emissionDateStart"
                :stopDate="searchform.emissionDateStop"
                :inputOpts="{
                label: $t('begin'),
                clearable: true,
                placeholder: ' ',
              }"
            ></smart-picker>
          </v-col>
          <v-col cols="6" class="pr-1">
            <smart-picker
                v-model="searchform.emissionDateStop"
                :startDate="searchform.emissionDateStart"
                :inputOpts="{
                label: $t('end'),
                clearable: true,
                placeholder: ' ',
              }"
            ></smart-picker>
          </v-col>

          <v-col cols="12" class="pt-5 mt-2">

            <smart-multi-select
                v-model="searchform.pricesFilter"
                label="Prix"
                :items="pricesFilter"
                :all-is-same-as-empty="true"
                :default-select-all="true"
            ></smart-multi-select>
          </v-col>

        </v-row>

        <smart-btn type="submit" :loading="listing.loading" block primary class="mt-4"
        >Rechercher
        </smart-btn
        >
        <smart-btn
            block
            tertiary
            @click.native="
            clearSearchform();
            loadData();
          "
        >Réinitialiser la recherche
        </smart-btn
        >
      </v-form>
    </template>
    <template slot="content">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-data-table
                ref="tickettable"
                class="tbl"
                :headers="headers"
                :items="tickets"
                :expand="true"
                :loading="listing.loading"
                :footer-props="{
                'items-per-page-options': listing.rowsPerPageItems,
                'items-per-page-text': 'Lignes par page',
              }"
                item-key="ref"
                :sort-by="['bookingDate']"
                no-data-text="Il n'y a pas de billet à émettre"
            >
              <template #item.bookingId="{value}">
                <v-chip @click="openBooking(value)"
                              label
                              flat
                              small
                              outlined
                              class="grey lighten-2 blue--text text--lighten-2 mr-1"
                      > {{value}}
                        <v-icon small class="ml-2">mdi-open-in-new</v-icon>
                      </v-chip>

              </template>
              <template #item.site="{ value }">
                <site-label :sitename="value"></site-label>
              </template>
              <template #item.bookingDate="{ value }">
                <div class="font-weight-regular">
                  {{
                    _parseAndFormatDate(
                        value,
                        datePatternConfig.serverLocalDateTime,
                        "dd/MM/yy"
                    )
                  }}
                </div>
                <div class="caption grey--text text--darken-1">
                  {{
                    _parseAndFormatDate(
                        value,
                        datePatternConfig.serverLocalDateTime,
                        datePatternConfig.fr.time
                    )
                  }}
                </div>
              </template>
              <template #item.startDate="{ value }">
                <div class="font-weight-regular">
                  {{
                    _parseAndFormatDate(
                        value,
                        datePatternConfig.serverLocalDateTime,
                        "dd/MM/yy"
                    )
                  }}
                </div>
              </template>
              <template #item.tickettingDate="{ value }">
                <div class="font-weight-regular">
                  {{
                    _parseAndFormatDate(
                        value,
                        datePatternConfig.serverLocalDateTime,
                        "dd/MM/yy"
                    )
                  }}
                </div>
              </template>
              <template #item.nego="{value}">
                <div style="width:50%"
                     class="mx-auto white--text rounded"
                     :class="[
                    value ? 'blue' : 'green'
                ]">{{ value ? "Négo" : "Pub" }}
                </div>
              </template>
              <template #item.status="{ value }">
                <availability :value="value" kind="SupplierStatus"/>
              </template>
              <template #item.check="{ item }">
                <v-tooltip top>
                  <template #activator="{ on }">
                    <v-btn v-on="on" fab small text @click="refresh(item)">
                      <v-icon>mdi-eye-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Vérification de l'emission</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </layout>
</template>

<script>
import ColorMixin from "@/components/mixins/ColorMixin";
import SiteLabel from "@/components/commons/SiteLabel";
import Availability from "@/components/commons/Availability";
import Layout from "@/views/Layout";
import {get, post} from "@/utils/api";
import {EventBus} from "@/components/commons/event-bus";
import SmartMultiSelect from "@/components/commons/SmartMultiSelect.vue";
import SmartSelect from "@/components/commons/SmartSelect.vue";
import {addYears, format} from "date-fns";

export default {
  name: "TickettingList",
  components: {
    SmartSelect, SmartMultiSelect,
    Layout,
    SiteLabel,
    Availability,
  },
  mixins: [ColorMixin],
  data() {
    return {
      searchform: null,
      defaultSearchForm: {
        pricesFilter: [],
        selectedSites: [],
        selectedVirtualSites: [],
        airlines: "",
        emissionDateStart: this._nowFormatted("dd/MM/yyyy"),
        emissionDateStop: format(addYears(new Date(), 1), "dd/MM/yyyy"),
        filtredPrice: false,
        nego: null
      },
      virtualSites: [],
      pricesFilter: [
        {id: 1, name: "Prix public"},
        {id: 2, name: "Prix négociés"},
      ],
      listing: {
        loading: true,
        rowsPerPageItems: [{text: "Tous", value: -1}, 50, 200],
      },
      headers: [
        {text: "Dossier", value: "bookingId", align: "center"},
        {text: "Client", value: "customerName", align: "center"},
        {text: "Site", value: "site", align: "center", sortable: true},
        {
          text: "Résa",
          value: "bookingDate",
          align: "center",
          sortable: true,
          sort: this.sortByDateTime,
        },
        {
          text: "Départ",
          value: "startDate",
          align: "center",
          sortable: true,
          sort: this.sortByDateTime,
        },
        {
          text: "Destination",
          value: "destinations",
          align: "center",
          sortable: true,
        },
        {text: "PNR", value: "pnr", align: "center"},
        {text: "Airline", value: "airline", align: "center", sortable: true},
        {text: "Négocié", value: "nego", align: "center", sortable: true},
        {
          text: "Emission",
          value: "tickettingDate",
          align: "center",
          sortable: true,
          sort: this.sortByDateTime,
        },
        {text: "Statut", value: "status", align: "center", sortable: false},
        {text: "", value: "check", sortable: false},
      ],
      tickets: [],
    };
  },
  created() {
    get("/api/search/virtual-sites").json((sites) => {
      this.virtualSites = sites;
      this.defaultSearchForm.selectedVirtualSites = this.virtualSites.map(
          (s) => s.id
      );
      this.searchform = this.defaultSearchForm
      this.loadData()
    });
  },
  watch: {},
  computed: {},
  methods: {
    loadData() {
      this.clearListing()
      const url = "/api/ticketting/list";
      let searchform = this.searchform
      if (this.searchform.airlines.includes(",")) {
        searchform.airlines = this.searchform.airlines.toUpperCase().split(",").map(code => code.trim())
      } else {
        searchform.airlines = this.searchform.airlines.length > 0 ? [this.searchform.airlines.toUpperCase().trim()] : []
      }

      if (this.searchform.pricesFilter.length == 1) {
        searchform.nego = this.searchform.pricesFilter[0] == 2
      } else searchform.nego = null

      post(url, this.searchform)
          .badRequest((br) => {
            console.log("Error: ", br);
          })
          .json((rs) => {
            rs.map((ticket) => {
              this.tickets.push(ticket);
            });
          })
          .then(() => (this.listing.loading = false));
    },
    clearListing() {
      this.tickets = []
    },
    clearSearchform() {
      this.searchform = {...this.defaultSearchform};
    },

    openBooking(id) {
      let route = this.$router.resolve({name: "Booking", params: {id: id}});
      window.open(route.href, "_blank");
    },
    customSort(items, index, isDesc) {
      const formatPattern = "yyyyMMdd";

      if (isDesc !== null) {
        items.sort((a, b) => {
          let aEl = a[index];
          let bEl = b[index];

          if (
              index === "bookingDate" ||
              index === "boardingDate" ||
              index === "tickettingDate"
          ) {
            aEl = this._parseAndFormatDate(
                a[index],
                this.datePatternConfig.serverLocalDateTime,
                formatPattern
            );
            bEl = this._parseAndFormatDate(
                b[index],
                this.datePatternConfig.serverLocalDateTime,
                formatPattern
            );
          }
          return !isDesc ? (aEl < bEl ? -1 : 1) : bEl < aEl ? -1 : 1;
        });
      }
      return items;
    },
    sortByDateTime(a, b) {
      return this._sortDates(a, b, this.datePatternConfig.serverLocalDateTime);
    },
    refresh(item) {
      this.listing.loading = true;
      const url = "/api/ticketting/list/refresh/";
      get(url + item.id).json((r) => {
        if (r.emitted) {
          let index = this.tickets.indexOf(item);
          this.tickets.splice(index, 1);
          EventBus.$emit("toaster-msg", "La prestation a bien été émise.");
        } else {
          EventBus.$emit("toaster-msg", "La prestation n'a pas été émise.");
        }
        this.listing.loading = false;
      });
    },
  },
};
</script>

<style></style>
